import { FormController } from '@form-ts/core';
import { FormError } from 'src/modules/form/types/FormError';
import { PasswordForgotFormData } from 'src/modules/password-forgot/types/PasswordForgotFormData';
import { createActions } from 'src/utils/createActions';

export const PASSWORD_FORGOT_SUBMIT =
  createActions<FormController<PasswordForgotFormData, FormError>, void>('PASSWORD_FORGOT_SUBMIT');
